
    import { mount } from "svelte";

    import "./src/global.css";
    import App from "./src/App.svelte";

    const app = mount(App, {
      target: document.body,
      props: {},
    });
  